// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';

import ApplyOptions from '../apply-options';
import JobDescriptionDialog from '../job-description-dialog';
import JobCompensation from '../job-compensation';
import { getCustomerLogoPath } from '../../util/customer';
import { IMAGE_PATH } from '../../util/config';
import { InactiveJob } from '../inactive-job';
import { CareersPageButton } from '../careers-page-button';

const styles = theme => ({
  media: {
    height: '200px',
  },
  darkOverlay: {
    height: '200px',
    position: 'relative',
    marginBottom: '-200px',
    bottom: '200px',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
  },
  card: {
    width: '100%',
  },
  overlay: {
    position: 'relative',
    left: '15px',
    bottom: '75px',
    marginBottom: '-25px',
    fontFamily: 'Roboto',
    zIndex: 100,
  },
  logo: {
    display: 'block',
    position: 'absolute',
    right: '30px',
    top: '-110px',
    maxWidth: '120px',
    marginBottom: '10px',
    background: 'rgba(255, 255, 255, 0.85)',
    padding: '5px',
  },
  header: {
    paddingBottom: '20px',
  },
  headline: {
    lineHeight: '1.1em',
    marginBottom: 0,
    align: 'left',
    color: 'white',
  },
  caption: {
    color: 'white',
  },
  applyText: {
    margin: '10px',
    padding: '0px 15px 0px 15px',
    fontWeight: 300,
  },
});

type Props = {
  classes: Object,
  job: Job,
  jobCompensation: Object | null,
  org: Org,
}

type State = {
}

class JobDescriptionC extends React.PureComponent<Props, State> {
  render() {
    const { classes, job, jobCompensation, org } = this.props;
    const { status } = job;
    const isJobHiring = ['PUBLISHED', 'ACTIVE'].includes(status);
    const logoPath = getCustomerLogoPath(org);

    return (
      <div style={{ width: '100%' }}>
        {/* TODO - open link in new window */}
        <Card className={classes.card}>
          { job.imagePath ?
            <CardMedia
              image={`${IMAGE_PATH}/${job.imagePath}`}
              className={classes.media}
            /> :
            <CardContent
              className={classes.media}
            />
          }
          <div className={classes.darkOverlay} />
          <div className={classes.overlay}>
            <a href={org.website} target="blank" rel="noopener noreferrer" >
              <img src={logoPath} className={classes.logo} alt="Home" />
            </a>
            <div className={classes.jobHeader}>
              <Typography variant="h5" className={classes.headline} gutterBottom>{job.title}</Typography>
              {job.city && job.state &&
                <Typography variant="caption" className={classes.caption} gutterBottom>{job.city}, {job.state}</Typography>
                }
              <br />
              <JobCompensation
                  offeredCompensation={jobCompensation}
                  typographyClass={classes.caption}
                  variant='typography'
                  typographyVariant="caption"
                />
            </div>
          </div>
          {isJobHiring ? (
            <>
              <ApplyOptions />
              <Typography variant="subtitle1" className={classes.applyText}>
                {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{ __html: job.shortDescription }} />
              </Typography>
              <Grid container alignItems="center" justify="center" className={classes.header}>
                <JobDescriptionDialog
                  job={job}
                  org={org}
                  jobCompensation={jobCompensation}
                />
              </Grid>
            </>
          ) : (
            <>
              <InactiveJob job={job} org={org} />
              <CareersPageButton org={org} />
            </>
          )}
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(JobDescriptionC);
